/** Mural de recados: avisos para a equipe e para os clientes. */
import { createFileRoute } from '@tanstack/react-router';
import { Mural } from '../telas/mural/mural';

export const Route = createFileRoute('/_app/mural')({ component: Mural });
